import React, { FunctionComponent } from 'react';
import { Skeleton, SkeletonHeight } from '@doveit/lego';
import ArticleSmallCard, { ArticleSmallCardProps, ArticleSmallCardSkeleton } from '../article-small-card/ArticleSmallCard';
import * as styles from './RelatedArticles.style';

export interface RelatedArticleItem extends ArticleSmallCardProps {
  id: string | number,
}

export interface RelatedArticleProps {
  title: string,
  items: Omit<RelatedArticleItem, 'onClick'>[],
  dataRef?: string,
}

export interface RelatedArticlesSkeletonProps {
  totalItems: number,
}

export const RelatedArticlesSkeleton: FunctionComponent<RelatedArticlesSkeletonProps> = ({
  totalItems,
}) => (
  <div>
    <div css={styles.title}>
      <Skeleton height={SkeletonHeight.LARGE} width="70%" />
    </div>
    <div css={styles.items}>
      {[...Array(totalItems)].map((_, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={`article-card-skeleton-${index}`}
          css={styles.item}
        >
          <ArticleSmallCardSkeleton />
        </div>
      ))}
    </div>
  </div>
);

const RelatedArticles: FunctionComponent<RelatedArticleProps> = ({
  title,
  items,
  dataRef = 'related-articles',
}) => (
  <div
    data-ref={dataRef}
  >
    <div
      css={styles.title}
      data-ref={`${dataRef}-title`}
    >
      {title}
    </div>
    <ul
      data-ref={`${dataRef}-list`}
      css={styles.items}
    >
      {items.map((item) => (
        <li
          key={item.id}
          css={styles.item}
        >
          <ArticleSmallCard
            {...item}
          />
        </li>
      ))}
    </ul>
  </div>
);

export default RelatedArticles;
